import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Divider, Grid } from '@mui/material';
import React, { FC, ReactNode, useState } from 'react';

import Item from '../Item/Item';
import WsTypography, { WsTypoVariants, WsTypoColors } from '../WsTypography/WsTypography';

interface ICandidateAccordion {
  header: string;
  children: ReactNode;
}

const CandidateAccordion: FC<ICandidateAccordion> = ({ header, children }) => {
  const [expand, setExpand] = useState<boolean>(true);
  return (
    <>
      <Grid container item xs={12}>
        <Item sx={{ width: '100%' }}>
          <WsTypography
            display="inline"
            variant={WsTypoVariants.SUB_TITLE}
            color={WsTypoColors.PRIMARY}
          >
            {header}
          </WsTypography>
          {!expand && (
            <ExpandMoreIcon
              onClick={() => setExpand(true)}
              sx={{ float: 'right', cursor: 'pointer' }}
            />
          )}
          {expand && (
            <ExpandLessIcon
              onClick={() => setExpand(false)}
              sx={{ float: 'right', cursor: 'pointer' }}
            />
          )}
          <Divider sx={{ mt: 1 }} />
        </Item>
      </Grid>
      {expand && (
        <Grid container item xs={12}>
          {children}
        </Grid>
      )}
    </>
  );
};

export default CandidateAccordion;
